import React from 'react'
import {FormattedNumber, FormattedMessage} from 'react-intl'

const unitToSymbol = (unit) => unit == 'm2' ? 
  <span>
    <FormattedMessage id="meter-symbol" defaultMessage="m"/>
    <sup>2</sup>
  </span> 
  : 
  <span>
    <FormattedMessage id="feet-symbol" defaultMessage="ft"/>
    <sup>2</sup>
  </span>

const Area = ({area, unit}) => {
  if(area == null) { return null }
  return <span> <FormattedNumber value={area}/>&nbsp;{unitToSymbol(unit)}</span>
}

export default Area




/** WEBPACK FOOTER **
 ** ./app/components/Area.jsx
 **/